// @flow

import {
  TextField,
  type Props as FieldProps,
} from 'src/Reshaped/Form/TextField';

import { ZipHelp } from './ZipHelp';

type Props = {
  ...Partial<FieldProps>,
  name: string,
  placeholder?: string,
};

export function Zip({
  label,
  name,
  control,
  help,
  placeholder,
  disabled,
  rules,
}: Props): React.MixedElement {
  return (
    <TextField
      name={name}
      label={label}
      control={control}
      disabled={disabled}
      rules={rules}
      inputProps={{ placeholder }}
      help={help || <ZipHelp />}
    />
  );
}
